import React from "react";
import { Outlet } from "react-router-dom";
import PopupHandlerLayout from "./PopupHandlerLayout";

export default function AuthLayout() {
  return (
    <>
      <PopupHandlerLayout />
      <Outlet />
    </>
  );
}
